import { createModelStore } from '@/shared/stores/create-model-store'
import { model1_2InitialModel } from './initial-state'
import { model1_2DimensionHandlers } from './dimensions'

export const useModel1_2Store = createModelStore({
  initialModel: model1_2InitialModel,
  dimensionHandlers: model1_2DimensionHandlers,
})
